import service from './service'

export default {
	getCategoryList: params =>
		service.get(`back/category/getSimpleList`, { params }),
	updateStatus: params => service.put(`back/category/updateStatus`, params),
}
